import { useEffect, useState } from 'react';
import apiService from '../services/apiService';

// Module-level cache: fetched once per page load
let snippetsCache = null;
let fetchPromise = null;

function loadSnippets() {
  if (snippetsCache) return Promise.resolve(snippetsCache);
  if (fetchPromise) return fetchPromise;
  fetchPromise = apiService.getSeoSnippets().then(res => {
    snippetsCache = res.snippets || {};
    return snippetsCache;
  }).catch(() => {
    snippetsCache = {};
    return snippetsCache;
  });
  return fetchPromise;
}

function setMeta(attr, attrValue, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.content = content;
}

function setCanonical(href) {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.href = href;
}

export function usePageMeta(fallbackTitle, fallbackDescription, pageKey, fallbackCanonical) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    loadSnippets().then(snippets => {
      if (cancelled) return;
      const s = (pageKey && snippets[pageKey]) || {};

      const title = s.title || fallbackTitle;
      const desc = s.meta_description || fallbackDescription;
      const ogTitle = s.og_title || title;
      const ogDesc = s.og_description || desc;
      const ogImage = s.og_image || null;
      const twTitle = s.twitter_title || title;
      const twDesc = s.twitter_description || desc;
      const canonical = s.canonical || fallbackCanonical;

      if (title) document.title = title;
      setMeta('name', 'description', desc);
      setMeta('property', 'og:title', ogTitle);
      setMeta('property', 'og:description', ogDesc);
      if (ogImage) setMeta('property', 'og:image', ogImage);
      setMeta('property', 'og:image:alt', ogTitle || 'AI Doctor Ben - Private AI health companion');
      setMeta('name', 'twitter:title', twTitle);
      setMeta('name', 'twitter:description', twDesc);
      if (ogImage) setMeta('name', 'twitter:image', ogImage);
      setCanonical(canonical);

      setReady(true);
    });

    return () => { cancelled = true; };
  }, [fallbackTitle, fallbackDescription, pageKey, fallbackCanonical]);

  return ready;
}
